import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core'
import { FormGroup, FormControl, Validators } from '@angular/forms'
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { Product } from '../../../models/product.model'

@Component({
  standalone: false,
  selector: 'vs-bom-product',
  templateUrl: './bom-product.component.html',
  styleUrls: ['./bom-product.component.scss'],
})
export class BomProductComponent implements OnInit, OnChanges {
  @Input() product: Product
  @Input() checked: boolean
  @Input() defaultSalesArea: any
  @Input() availableAt: []
  @Output() bomProduct = new EventEmitter<Product>()
  @Input() catalog: boolean
  quantity: number
  hasStock: boolean
  maxQuantity: number
  addBOMToCartForm = new FormGroup({
    quantity: new FormControl(1),
    availableAt: new FormControl(null, [Validators.required]),
  })
  selectedLegalEntity
  count = 1
  loggedIn: boolean
  constructor(
    public auth: AuthService,
    private globalMessageService: GlobalMessageService
  ) {}

  ngOnInit(): void {
    this.setStockInfo(this.product)
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.loggedIn = true
      } else {
        this.loggedIn = false
      }
    })
    this.selectedLegalEntity = this.defaultSalesArea
    this.addBOMToCartForm.controls.availableAt.valueChanges.subscribe(
      (data) => {
        this.selectedLegalEntity = data
      }
    )
  }
  private setStockInfo(product: any): void {
    this.quantity = 1
    this.hasStock =
      product.stock && product.stock.stockLevelStatus !== 'outOfStock'
    if (this.hasStock && product.stock.stockLevel) {
      this.maxQuantity = product.stock.stockLevel
    }

    this.addBOMToCartForm.controls.availableAt.setValue(
      this.defaultSalesArea?.salesOrganization
    )
  }
  ngOnChanges(changes) {
    if (changes?.checked?.currentValue != changes?.checked?.previousValue) {
      this.setChecked(changes.checked.currentValue)
    }
  }
  setChecked(checked) {
    this.checked = checked
    let obj = {
      product: {
        code: this.product.code,
      },
      checked: checked,
      quantity: this.count,
      legalEntity: this.selectedLegalEntity?.code,
    }
    this.bomProduct.emit(obj)
  }
  getCount(count) {
    this.count = count
    this.changeProperty()
  }
  changeProperty() {
    let obj = {
      product: {
        code: this.product.code,
      },
      checked: this.checked,
      quantity: this.count,
      legalEntity: this.selectedLegalEntity?.code,
    }
    this.bomProduct.emit(obj)
  }
}
